module.exports = __webpack_public_path__ + "static/img/Seat-Branding.510d5d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advertisingImagesNew/Seat-Branding.jpg
// module id = GrJq
// module chunks = 12